"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorToString = errorToString;
const validation_1 = require("./validation");
function errorToString(err) {
    if (err instanceof Error) {
        return err.message + showCause(err);
    }
    else if (typeof err === 'string') {
        return err;
    }
    else if ((0, validation_1.isObject)(err) && typeof err.error === 'string') {
        return typeof err.message === 'string' ? `${err.error}: ${err.message}` : err.error;
    }
    else if ((0, validation_1.isObject)(err) && typeof err.message === 'string') {
        return err.message;
    }
    else if ((0, validation_1.isObject)(err) && (0, validation_1.isObject)(err.json) && typeof err.json.message === 'string') {
        return err.json.message;
    }
    else {
        return JSON.stringify(err);
    }
}
function showCause(err) {
    if ('cause' in err && err.cause instanceof Error) {
        return `\n  cause: ${errorToString(err.cause)}`;
    }
    else {
        return '';
    }
}
//# sourceMappingURL=error.js.map